<template>
    <el-image style="width: 100%; height: 100%" :src="require('@/assets/grade.png')"></el-image>
</template>

<script>
export default {
  data() {
    return {
      src: './assets/grade.png'
    };
  },
  methods: {},
  mounted() {},
};
</script>
<style scoped>
</style>>
